import { qsa } from "@fluorescent/dom";
import { delayOffset } from "@/lib/animation";

const selectors = {
  items: ".animation--item",
  slide: ".slideshow__cell",
};

export default node => {
  const slides = qsa(selectors.slide, node);
  slides.forEach(slide => delayOffset(slide, [selectors.items]));
};
